import { useState, useEffect } from 'react';
import { SidebarStateManager, SidebarType, SidebarState } from '../utils/SidebarStateManager';

/**
 * React hook for managing sidebar state
 */
export function useSidebarState(sidebarManager: SidebarStateManager) {
  const [sidebarState, setSidebarState] = useState<SidebarState>(sidebarManager.getState());

  useEffect(() => {
    const unsubscribe = sidebarManager.subscribe((newState) => {
      setSidebarState(newState);
    });

    return unsubscribe;
  }, [sidebarManager]);

  return {
    activeSidebar: sidebarState.activeSidebar,
    previousSidebar: sidebarState.previousSidebar,
    isSidebarActive: (sidebarType: SidebarType) => sidebarManager.isSidebarActive(sidebarType),
    openSidebar: (sidebarType: SidebarType) => sidebarManager.openSidebar(sidebarType),
    closeSidebar: () => sidebarManager.closeSidebar(),
    closeSpecificSidebar: (sidebarType: SidebarType) => sidebarManager.closeSpecificSidebar(sidebarType),
    closeAllSidebars: () => sidebarManager.closeAllSidebars(),
    toggleSidebar: (sidebarType: SidebarType) => sidebarManager.toggleSidebar(sidebarType),
    hasActiveSidebar: () => sidebarManager.hasActiveSidebar()
  };
}